import { component } from 'picoapp'
import { addVariant } from '@/lib/cart.js'
// import { nextUntil } from '@/lib/nextuntil.js'

export default component((node, ctx) => {
  const json = JSON.parse(node.querySelector('.js-product-json').innerHTML)
  const form = node.querySelector('form')

  const { selectedOrFirstAvailableVariant, product } = json
  let currentVariant = product.variants.filter(v => v.id === selectedOrFirstAvailableVariant)[0]

  form.addEventListener('submit', e => {
    e.preventDefault()
    currentVariant = product.variants.filter(v => v.id === parseInt(form.elements.id.value))[0]

    addVariant(currentVariant, form.elements.quantity.value)
  })

  // document.querySelector('.js-variant').style.display = 'none';

  // init image slider
  const sliderWrapper = node.querySelector('.product-detail__image-slider');
  const thumbnails = node.querySelectorAll('.product-detail__thumbnail');
  let initialIndex = node.querySelector('.product-detail__image-slide.is-selected').getAttribute('data-index');
  const hasOnlyDefaultVariant = !!node.querySelector('.product-detail.has-only-default-variant');

  if (hasOnlyDefaultVariant) {
    initialIndex = 0;
  }


  
  if (node.querySelectorAll('.product-detail__image-slide').length > 1) {

    let flickityOptions = {
      pageDots: true,
      initialIndex: initialIndex
    };

    if (!hasOnlyDefaultVariant) {
      flickityOptions.draggable = false;
      node.querySelector('.product-detail__thumbnails').style.display = 'none';
    }
    
    let productImagesFlickity = new Flickity(sliderWrapper, flickityOptions);

    // call resize after the page loads to fix bug with pjax
    setTimeout(function() {
      productImagesFlickity.resize();
    }, 500);

    productImagesFlickity.on('change', function(index) {
      for (let i = 0; i < thumbnails.length; i++) {
        thumbnails[i].classList.remove('is-selected');
      }
      thumbnails[index].classList.add('is-selected');
    });

    for (let i = 0; i < thumbnails.length; i++) {
      thumbnails[i].addEventListener('click', function() {
        productImagesFlickity.select(thumbnails[i].getAttribute('data-index'));
      })
    }


    ctx.on('variantselected', variant => {

      if (variant.image_id == null) {
        // Professional variants may not have image_ids, so
        // we need to look at the non-pro variant for it

        var customerTag = slater.qs('.product-detail').dataset['customerTag'];
        var consumerVariant = json.product.variants.filter(function(v) {
          return variant.title.replace(' (' + customerTag + ')', '') == v.title;
        });
        
        if (consumerVariant[0]) {
          variant.image_id = consumerVariant[0].featured_image.id;
        }
      }
      
      const variantImageSlide = document.querySelector('.product-detail__image-slide[data-id="'+ variant.image_id +'"]');
      const slideIndex = variantImageSlide.getAttribute('data-index');

      if (slideIndex) {
        productImagesFlickity.select(slideIndex);
      }

      document.querySelector('.variant-sku').innerHTML = ''; 
      document.querySelector('.variant-upc').innerHTML = ''; 

      if (variant.sku) {
        document.querySelector('.variant-sku').innerHTML = 'SKU: ' + variant.sku
      }
      if (variant.barcode) {
        document.querySelector('.variant-upc').innerHTML = 'UPC: ' + variant.barcode
      }
      
    });
    
  }

  // if no variant is pre-selected (professional is logged in),
  // select the first variant on the page
  // let mainSelect = form.querySelector('#selectid');
  // if (mainSelect.value == '') {
    const firstOption = form.querySelectorAll('input[type="radio"]')[0];
    firstOption.click();
  // }


  // init product image zoom hover
  const imageSlides = node.querySelectorAll('.product-detail__image');

  for (let i = 0; i < imageSlides.length; i++) {
    imageSlides[i].addEventListener('mousemove', imageHovered);
  }

  function imageHovered(e) {
    let offsetX, offsetY;
    let zoomer = e.currentTarget;
    e.offsetX ? offsetX = e.offsetX : offsetX = e.touches[0].pageX;
    e.offsetY ? offsetY = e.offsetY : offsetX = e.touches[0].pageX;
    // const x = 100 - (offsetX/zoomer.offsetWidth * 100);
    const x = offsetX/zoomer.offsetWidth * 100;
    const y = offsetY/zoomer.offsetHeight * 100;
    zoomer.style.backgroundPosition = x + '% ' + y + '%';
  }

  // clicking star rating opens the Reviews tab
  const starRating = node.querySelector('.review-widget');
  const reviewsHeading = node.querySelector('.product-detail__reviews-heading');

  starRating.addEventListener('click', function() {
    reviewsHeading.click();
    setTimeout(function() {
      reviewsHeading.scrollIntoView();
    }, 1);
  });


  // reboot Bold Custom Pricing JS
  // setTimeout(function() {
  //   window.BOLD = null;
  //   var head = document.getElementsByTagName('head')[0];
  //   var script = document.createElement('script');
  //   script.src = 'https://static.boldcommerce.com/bold-platform/sf/pr.js';
  //   head.appendChild(script);
  // }, 250);

})
